import { Helmet } from 'react-helmet-async';
// @mui
import { Stack, Typography, Grid, Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';

import moment from 'moment';

import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

export default function HomePage() {
  const [row, setRow] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    const arr = [];
    get(child(dbref(rtdb), `announcement`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((doc) => {
            arr.push({
              ...doc.val(),
            });
          });

          setRow(arr);
          setLoading(false);
        } else {
          setRow([]);
          setLoading(false);
          console.log('No data available');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  if (loading) {
    return (
      <Grid style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Helmet>
        <title> Announcement | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid
        style={{
          top: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        {matches ? (
          <Grid
            style={{
              zIndex: -1,
              position: 'fixed',
              top: 0,
              backgroundColor: '#1b0049',
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <video height="100%" className="videoTag" playsInline autoPlay loop muted>
              <source src="/assets/videobg.mp4" type="video/mp4" />
            </video>
          </Grid>
        ) : (
          <Grid
            style={{
              zIndex: -1,
              position: 'fixed',
              top: 0,
              backgroundColor: '#1b0049',

              height: '110vh',
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <video height="100%" className="videoTag" playsInline autoPlay loop muted>
              <source src="/assets/videobg.mp4" type="video/mp4" />
            </video>
          </Grid>
        )}

        <Grid
          style={{
            maxWidth: 1200,
            zIndex: 1,
            marginTop: 120,
            width: '100%',
            display: 'flex',
            padding: 25,
            paddingTop: 60,
            paddingBottom: 80,
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: 'Transparent',
          }}
        >
          <Typography style={{ fontWeight: 'bold', fontSize: 40, color: 'white', textTransform: 'uppercase' }}>
            Announcement
          </Typography>
          <Typography
            style={{ marginTop: -10, fontWeight: 'lighter', fontSize: 40, color: 'white', textTransform: 'uppercase' }}
          >
            Exciting News Ahead
          </Typography>
          <Typography style={{ maxWidth: 500, marginTop: 20, fontWeight: 300, fontSize: 16, color: 'white' }}>
            Ready for the Next Level
          </Typography>
        </Grid>

        <Grid
          style={{
            zIndex: 1,
            backgroundColor: '#1b0049',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Grid
            style={{
              padding: 25,
              maxWidth: 1200,
              marginTop: 10,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              backgroundColor: 'Transparent',
            }}
          >
            <Typography
              style={{
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: 36,
                color: 'white',
                textTransform: 'uppercase',
              }}
            >
              Announcement
            </Typography>
            {row.length > 0 ? null : (
              <Typography variant="body2" style={{ marginTop: 20, fontWeight: 'bold', fontSize: 18, color: 'white' }}>
                No announcements has been posted yet
              </Typography>
            )}
          </Grid>

          <Grid container spacing={4} style={{ padding: 25, maxWidth: 1200 }}>
            {row.map((val) => (
              <Grid item sm={6} md={4} lg={3} xs={12}>
                <Grid>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea href={`/announcement/${val.prefix}`}>
                      {val.thumbnail_fullPath ? (
                        <CardMedia component="img" height="140" image={val.thumbnail_fullPath} alt={val.title} />
                      ) : null}
                      <CardContent>
                        <Typography
                          sx={{ fontSize: 14, fontWeight: 'bold', color: '#1b0049', textTransform: 'uppercase' }}
                        >
                          {val.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            fontSize: 12,
                            color: '#af9ad3',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: '3',
                            WebkitBoxOrient: 'vertical',
                          }}
                        >
                          {val.description}
                        </Typography>

                        <Typography variant="body2" sx={{ mt: 1, fontSize: 10, color: '#af9ad3' }}>
                          {`${moment.utc(val.date).format('DD/MM/YYYY')}`}
                        </Typography>

                        <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: 10, color: '#af9ad3' }}>
                          {val.venue}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              </Grid>
            ))}
            })}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
